import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "./index.css";
import { initObservability } from "./lib/observability.js";
import { applyCustomCss } from "./lib/custom-css.js";
import { Dashboard } from "./routes/Dashboard.js";
import { OAuthCallback } from "./routes/OAuthCallback.js";
import { Login } from "./routes/Login.js";
import { VerifyMagicLink } from "./routes/VerifyMagicLink.js";
import { AcceptInvite } from "./routes/AcceptInvite.js";
import { RequireAuth } from "./routes/RequireAuth.js";

initObservability();
// Re-apply custom CSS from IndexedDB on every page load (Tier 3 only;
// no-op if not configured or `?nocss=1` is set).
void applyCustomCss();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login/verify" element={<VerifyMagicLink />} />
        <Route path="/team/accept" element={<AcceptInvite />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route path="/oauth/callback/google" element={<OAuthCallback />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
